var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMingcuteTruckLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #e8e8e8;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.6,23.3h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,.4,0,.4h0s0,0,0,0h.1c0,0,0,0,0,0h0s.1,0,.1,0h0s0,0,0,0v-.4s0,0,0,0M12.9,23.1h0s-.2,0-.2,0h0s0,0,0,0v.4s0,0,0,0h0s.2.1.2.1c0,0,0,0,0,0h0s0-.6,0-.6c0,0,0,0,0,0M12.1,23.1s0,0,0,0h0s0,.6,0,.6c0,0,0,0,0,0h0s.2,0,.2,0h0s0,0,0,0v-.4s0,0,0,0h0s-.2-.1-.2-.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15,4c1.1,0,2,.9,2,2v1h1.5c.6,0,1.2.3,1.6.8l1.5,1.9c.3.4.4.8.4,1.2v4.1c0,1.1-.9,2-2,2,0,1.7-1.3,3-3,3s-3-1.3-3-3h-4c0,1.7-1.3,3-3,3s-3-1.3-3-3c-1.1,0-2-.9-2-2V6c0-1.1.9-2,2-2h11ZM7,16c-.6,0-1,.4-1,1s.4,1,1,1,1-.4,1-1-.4-1-1-1M17,16c-.6,0-1,.4-1,1s.4,1,1,1,1-.4,1-1-.4-1-1-1M15,6H4v9h.8c1.1-1.2,3-1.3,4.2-.2,0,0,0,0,.1.1h.1c0,.1,5.5.1,5.5.1h.1c0-.1.1-.2.1-.2V6ZM18.5,9h-1.5v5c.8,0,1.6.3,2.1.9h.1c0,.1.8.1.8.1v-4.2l-1.5-1.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteTruckLine);
export default __webpack_public_path__ + "static/media/mingcute--truck-line.ed8ea46b83355e50fef289972856d6e3.svg";
export { ForwardRef as ReactComponent };